import { LoadedWorkflowV5 } from '../migrateTo5';

type VisualWorkflowV6 = LoadedWorkflowV5['visualWorkflow'] & {
  batches: number;
};

export type LoadedWorkflowV6 = Omit<LoadedWorkflowV5, 'visualWorkflow'> & {
  visualWorkflow: VisualWorkflowV6;
};

export const _migrateTo6 = (
  loadedWorkflow: LoadedWorkflowV5
): LoadedWorkflowV6 => {
  return {
    ...loadedWorkflow,
    visualWorkflow: {
      ...loadedWorkflow.visualWorkflow,
      batches: 1,
    },
  };
};
